/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Watch(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M175.29687,63.53107l-6.23339-34.38556A15.99062,15.99062,0,0,0,153.31982,16H102.68018A15.99062,15.99062,0,0,0,86.93652,29.14551l-6.2334,34.38556a79.89661,79.89661,0,0,0,0,128.93786l6.2334,34.38556A15.99062,15.99062,0,0,0,102.68018,240h50.63964a15.99062,15.99062,0,0,0,15.74366-13.14551l6.23339-34.38556a79.8966,79.8966,0,0,0,0-128.93786ZM102.68018,32h50.64013l3.90723,21.55316a79.69216,79.69216,0,0,0-58.45508,0Zm50.63964,192H102.67969l-3.90723-21.55316a79.69216,79.69216,0,0,0,58.45508,0ZM168,136H128a8.00008,8.00008,0,0,1-8-8V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z" />
    </Svg>
  );
}

export default Watch;
